<template>
 <div>
 <template>
  <SectionNavbar
    v-if="$isTargetShop()"
    :imgCover="imgCover"
  />
  <SectionNavbar
    v-else
    :position="210"
    :imgCover="imgCover"
  />
  </template>
  <transition name="fade" v-if="member">
    <section>
      <Promotions
        v-if="$isTargetShop()"
        :style="$isTargetShop?'position: relative;bottom: 30px':''"
      ></Promotions>
      <Promotions
        v-else
        :top="210"
      ></Promotions>
      <PromotionCard  :style="$isTargetShop?'position: relative;bottom: 30px':''"></PromotionCard>
    </section>
  </transition>
  <section class="mb-4"  v-if="member"  :style="$isTargetShop?'position: relative;bottom: 30px':''">
    <Rewards ></Rewards>
    <RewardCard></RewardCard>
  </section>
  <v-overlay :value="overlay">
    <v-progress-circular
      indeterminate
      size="64"
      color="#F3E9DD"
    ></v-progress-circular>
  </v-overlay>
 </div>
</template>
<style scoped>
#primary {
  background-color: #181446;
}
body {
  background-color: #fff !important;
}
.v-sheet.v-card {
    border-radius: 18px;
}
</style>
<script>
import RewardCard from '../Layouts/RewardCard.vue'
import PromotionCard from '../Layouts/PromotionCard.vue'
import SectionNavbar from '../Layouts/SectionNavbar.vue'
import Promotions from '../Layouts/Promotions.vue'
import Rewards from '../Layouts/Rewards.vue'
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
// import moment from 'moment'
export default {
  name: 'LMGHome',
  metaInfo: {
    title: this.pageTitle,
    meta: [
      { property: `og:title`, content: 'สมัครรับคะแนนฟรี 10 คะแนน' },
      { property: 'og:image', content: 'https://storage.googleapis.com/betask-linked/static/upload/Shop/SH261_20221229231505684117.jpeg' }
    ]
  },
  components: {
    SectionNavbar,
    Promotions,
    PromotionCard,
    Rewards,
    RewardCard
  },
  data () {
    return {
      pageTitle: 'My Open Graph Title',
      positionCard: '',
      overlay: true,
      items: null,
      memberId: null,
      DateNow: new Date(),
      shopId: null,
      profile: null,
      member: this.GET_MEMBERINFO(),
      theme: null,
      month: null,
      show: false,
      shopData: null,
      imgCover: null,
      levelById: null
    }
  },
  async beforeMount () {
    this.shopId = await this.GET_SHOPID()
  },
  async mounted () {
    try {
      window.scrollTo(0, 0)
      this.member = await this.GET_MEMBERINFO()
      this.profile = await this.getLiffProfile()
      this.theme = await this.GET_THEME()
      this.imgCover = this.theme.imageCoverUrl
      this.overlay = false

      await this.getMemberProfile()

      // ⚠️ IMPORTANT: Re-fetch member data after getMemberProfile completes
      this.member = await this.GET_MEMBERINFO()

      // ตรวจสอบว่ามาจาก "already registered" alert หรือไม่
      const fromRegister = this.$route.query.fromRegister

      // Only redirect to registration if:
      // 1. member is truly null/undefined
      // 2. NOT coming from "already registered" alert (would cause loop)
      if (!this.member && fromRegister !== 'already') {
        this.$router.push(`/RegisterMember?shopId=${this.shopId}&type=welcome`)
        window.location.href = `/RegisterMember?shopId=${this.shopId}&type=welcome`
        return // Stop execution here
      }

      // If coming from "already registered" but still no member data, try one more time
      if (!this.member && fromRegister === 'already') {
        await this.getMemberProfile()
        this.member = await this.GET_MEMBERINFO()
      }

      if (this.shopId !== undefined && this.shopId !== null) {
        await this.chkName()
        await this.getCoinExpireNoti()
        this.overlay = false
      } else {
        this.$router.push('/MemberShop?redirectUrl=/home')
      }
      await this.transactionVisitPage()
      window.scrollTo(0, 0)
      this.show = true
      await this.getLevelById()
      this.overlay = false
      if (
        this.$isTargetShop() ||
        this.shopId === 'U93c42b54e45cfe584473c03e35746955' ||
        this.shopId === 'U9793e097e632d954bced75f0ad3610d2') {
      } else {
        this.$router.push('/')
      }
    } catch (e) {
      console.error('🔴 ERROR in mounted:', e)
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME']),
    async getLevelById () {
      const result = await this.callBeTaskAPI(
        'get',
        `/level/getID?RECORD_STATUS=N&levelId=${this.member.levelId}`
      )
      if (result) {
        this.levelById = result
      } else {
        this.levelById = null
      }
    },
    HEXToVBColorLMG (hex) {
      if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(hex)) {
        return '#E0E0E0'
      }

      let rr = parseInt(hex.substring(1, 3), 16)
      let gg = parseInt(hex.substring(3, 5), 16)
      let bb = parseInt(hex.substring(5, 7), 16)

      let brightness = (rr * 0.299) + (gg * 0.587) + (bb * 0.114)

      //

      if (brightness > 180) {
        return '#1A1446' // สีเข้ม
      } else {
        return '#FFFFFF' // สีขาว
      }
    },
    async chkName () {
      // เช็คว่า member มีข้อมูลครบหรือไม่ (firstname หรือ nameCustomer)

      if (!this.member) {
        return
      }

      // เช็คว่ามีข้อมูล firstname หรือ nameCustomer หรือไม่
      const hasFirstname = this.member.firstname && this.member.firstname !== ''
      const hasNameCustomer = this.member.nameCustomer && this.member.nameCustomer !== ''
      if (!hasFirstname && !hasNameCustomer) {
        const currentUrl = window.location.pathname
        const redirectUrl = encodeURIComponent(currentUrl + window.location.search)
        this.$router.push(`/RegisterMember?shopId=${this.shopId}&memberId=${this.member.memberId || ''}&redirectUrl=${redirectUrl}`)
      } else {
      }
    },
    async getCoinExpireNoti () {
      try {
        const params = {
          lineUserId: this.profile.userId,
          shopId: this.shopId
        }
        const result = await this.callBeTaskAPI('get', `/get-expire-coin-by-useId/get`, params)
        if (result.length > 0) {
          this.expireAllcCoin = result.reduce(
            (prev, cur) => parseInt(prev) + parseInt(cur.details),
            0
          )
        }
      } catch (err) {
        console.error(err)
      }
    },
    async checkNotify () {
      if (this.b === 'Yes') {
        try {
          await axios.post(this.DNS_IP + `/checkDontShow/update?lineUserId=${this.profile.userId}&shopId=${this.shopId}`, { headers: {lineUserId: this.profile.userId, lineId: this.profile.userId, shopId: this.shopId} })
        } catch (err) {
          console.error('err:', err)
        }
      } else {
        this.dialog = false
      }
    },
    async getReward () {
      try {
        const result = await this.callBeTaskAPI('get', `/reward/line/get?trending=True&quota=0&RECORD_STATUS=N`)
        if (result.length > 0) {
          this.items = result
        }
      } catch (err) {
        console.error(err)
      }
    },
    async transactionVisitPage () {
      try {
        const result = await this.callBeTaskAPI(
          'post',
          `/TransactionVisitPage/add`, {
            page: 'Home',
            shopId: this.member.shopId,
            CREATE_USER: this.member.lineUserId
          }
        )
        if (result) {
        }
      } catch (err) {
        console.error('err', err)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomeCUSTOM/Home.vue